import { List, Record } from 'immutable';
import { CONTENT_UPDATE, SLIDER_UPDATE } from './actions';

export const SECTION_TEXT = 'Text section';
export const SECTION_LIST = 'List section';

export const BANNER_SMALL = 'Small Banner';
export const BANNER_CTA = 'CTA Banner';
export const BANNER_NON_CTA = 'non-CTA Banner';

export const BANNER_HEADER_TEXT = 'Text';
export const BANNER_HEADER_IMAGE = 'Logo';

const TextSection = new Record({
  title: '',
  subtitle: '',
  text: ''
});

const ListSection = new Record({
  title: '',
  subtitle: '',
  list: new List()
});

const Banner = new Record({
  id: '',
  type: '',
  title: '',
  showTitle: false,
  headerType: '',
  headerTitle: '',
  headerTextColor: '',
  headerImage: '',
  backgroundColor: '',
  backgroundImage: '',
  offerText: '',
  subText: '',
  additionalText: '',
  image: '',
  ctaButtonText: '',
  ctaButtonTextColor: '',
  ctaButtonBackgroundColor: '',
  ctaUrl: '',
  ctaTarget: '',
  kqcText: '',
  termsText: '',
  termsTextColor: '',
  termsUrl: ''
});

const Slider = new Record({
  name: '',
  displayDuration: 8,
  rotations: new List()
});

const ScheduleModel = new Record({
  startDate: '',
  endDate: '',
  dailyScheduleEnabled: false,
  frequencyOption: null,
  customFrequencyDays: new List(),
  timeRanges: new List(),
  noExpiry: false
});

export const InitialState = new Record({
  terms: new TextSection(),
  responsibleGambling: new TextSection(),
  loginOnlineTerms: new TextSection(),
  registerOnlineTerms: new TextSection(),
  privacy: new TextSection(),
  support: new List(),
  homepageSliders: new List()
});

const ignoreDashes = text => ((text === '-' || text === '<p>-</p>') ? '' : text);
const processFakeUrl = (url = '') => url
  .replace(/^https?:\/\/([a-zA-Z]+)$/, '$1')
  .replace(/^https?:\/\/(plus|plusbeta)\.[^/]+(\/.*)$/, '$2');

const mapBanners = (section = {}, index = 'unknown') => section && new Banner({
  id: index,
  type: section.type,
  title: section.sectionTitle,
  showTitle: section.showSectionTitle && section.showSectionTitle.length > 0 && section.showSectionTitle[0] === 'show',
  headerType: section.header ? section.header.type : BANNER_HEADER_IMAGE,
  headerTitle: ignoreDashes(section.header ? section.header.title : ''),
  headerTextColor: section.header ? section.header.headerTextColour : '',
  headerImage: section.header ? section.header.image : '',
  backgroundColor: section.headerBackgroundColor,
  backgroundImage: section.backgroundMobileImage || section.backgroundImage,
  offerText: ignoreDashes(section.offerText),
  subText: ignoreDashes(section.subText),
  additionalText: ignoreDashes(section.additionalText),
  image: section.logoMobileImage || section.image || section.bannerImage,
  ctaButtonText: ignoreDashes(section.ctaButton || section.ctaButtonText),
  ctaButtonTextColor: section.ctaButtonTextColor,
  ctaButtonBackgroundColor: section.ctaButtonBackgroundColor,
  ctaUrl: processFakeUrl(section.url || section.ctaUrl),
  ctaTarget: section.target,
  kqcText: section.kqcText,
  termsText: section.tcText,
  termsTextColor: section.tcTextColor,
  termsUrl: section.tcUrl
});

const mapContentSection = section => (section.type === SECTION_TEXT
  ? new TextSection({
    title: section.sectionTitle,
    subtitle: section.sectionSubtitle,
    text: section.text
  })
  : new ListSection({
    title: section.sectionTitle,
    subtitle: section.sectionSubtitle,
    list: new List(section.list.map(item => new TextSection({
      title: item.sectionTitle,
      text: item.text
    })))
  }));

const mapContentSubsection = (
  (section, i) => (section && section[i] ? mapContentSection(section[i]) : new TextSection())
);

const mapSliders = slider => new Slider({
  name: slider.name,
  displayDuration: slider.displayDuration,
  rotations: new List(
    slider.rotations.map(rotation => {
      const defaultBanner = rotation.banners.default.banner;
      return {
        default: mapBanners(defaultBanner.data, defaultBanner.id),
        scheduled: new List(
          rotation.banners.scheduled ? rotation.banners.scheduled
            .filter(item => item.schedule && item.banner)
            .map(item => ({
              schedule: new ScheduleModel({
                startDate: item.schedule.startDate,
                endDate: item.schedule.endDate,
                dailyScheduleEnabled: item.schedule.dailyScheduleEnabled,
                frequencyOption: item.schedule.frequencyOption,
                customFrequencyDays: new List(item.schedule.customFrequencyDays),
                timeRanges: new List(item.schedule.timeRanges),
                noExpiry: item.schedule.noExpiry
              }),
              banner: mapBanners(item.banner.data, item.banner.id)
            })) : []
        )
      };
    }))
});

export default (state = new InitialState(), action) => {
  const { type } = action;

  switch (type) {
    case CONTENT_UPDATE: {
      return state.merge({
        terms: mapContentSubsection(action.data.termsandconditions, 0),
        responsibleGambling: mapContentSubsection(action.data.termsandconditions, 1),
        loginOnlineTerms: mapContentSubsection(action.data.termsandconditions, 2),
        registerOnlineTerms: mapContentSubsection(action.data.termsandconditions, 3),
        privacy: mapContentSubsection(action.data.privacy, 0),
        support: new List(action.data.support ? action.data.support.map(mapContentSection) : [])
      });
    }
    case SLIDER_UPDATE: {
      return state.set('homepageSliders', new List(action.data.length ? action.data.map(mapSliders) : []));
    }
    default:
      return state;
  }
};
